import { render, staticRenderFns } from "./list-item-image.vue?vue&type=template&id=c90913de&"
import script from "./list-item-image.vue?vue&type=script&lang=js&"
export * from "./list-item-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports